module.exports = __webpack_public_path__ + "static/media/vaibhav_logo_round.0d4e0502.png";